import { BROWSER, DEV } from "@workwave-tidal/env";
import { BROWSER as BROWSER2, DEV as DEV2 } from "@workwave-tidal/env";
function isDev() {
  try {
    return DEV && BROWSER;
  } catch (_e) {
    return false;
  }
}
export {
  BROWSER2 as BROWSER,
  DEV2 as DEV,
  isDev
};
//# sourceMappingURL=isDev.js.map
